/**
 * Panic gesture state — 5 rapid taps to silently dispatch a Police alert.
 *
 * Persisted in localStorage:
 *   - rr_panic_enabled: "1" if user opted in (default OFF)
 *   - rr_panic_last:    timestamp of last trigger (rate-limit 5 min)
 */

const KEY_ENABLED = "rr_panic_enabled";
const KEY_LAST = "rr_panic_last";

export const PANIC_TAP_COUNT = 5;
export const PANIC_TAP_WINDOW_MS = 2000;
export const PANIC_COUNTDOWN_MS = 3000;
export const PANIC_RATE_LIMIT_MS = 5 * 60 * 1000;

const listeners = new Set();

const readEnabled = () => {
  try { return localStorage.getItem(KEY_ENABLED) === "1"; }
  catch (_e) { return false; }
};

let enabledCache = readEnabled();

export const panic = {
  isEnabled() { return enabledCache; },
  setEnabled(v) {
    enabledCache = !!v;
    try {
      if (enabledCache) localStorage.setItem(KEY_ENABLED, "1");
      else localStorage.removeItem(KEY_ENABLED);
    } catch (e) { /* noop */ void e; }
    listeners.forEach((fn) => { try { fn(enabledCache); } catch (e) { /* noop */ void e; } });
  },
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  canTrigger() {
    try {
      const last = parseInt(localStorage.getItem(KEY_LAST) || "0", 10);
      if (!last) return true;
      return Date.now() - last >= PANIC_RATE_LIMIT_MS;
    } catch (_e) { return true; }
  },
  markTriggered() {
    try { localStorage.setItem(KEY_LAST, String(Date.now())); } catch (e) { /* noop */ void e; }
  },
  msUntilNext() {
    try {
      const last = parseInt(localStorage.getItem(KEY_LAST) || "0", 10);
      if (!last) return 0;
      return Math.max(0, PANIC_RATE_LIMIT_MS - (Date.now() - last));
    } catch (_e) { return 0; }
  },
};
